<template>
  <v-combobox
    v-model="selected"
    :items="produtos"
    item-text="text"
    item-value="value"
    label="Selecione os produtos"
    multiple
    chips
    clearable
    :style="{ minHeight: '55px' }"
    outlined
    @change="emitSelectedValues"
  >
    <!-- Chips com cor -->
    <template v-slot:selection="{ item, index }">
      <v-chip
        :key="index"
        :color="item.color || 'primary'"
        dark
        close
        @click:close="removeItem(item)"
      >
        {{ item.text }}
      </v-chip>
    </template>

    <!-- "Selecionar todos" -->
    <template v-slot:prepend-item>
      <v-list-item ripple @click="toggleSelectAll">
        <v-list-item-action>
          <v-checkbox
            :input-value="isAllSelected"
            :indeterminate="isIndeterminate"
            color="primary"
          ></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Selecionar todos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: 'ProdutoCombobox',
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: [],
    };
  },
  computed: {
    produtos() {
      return [...this.items].sort((a, b) => (a.order || 0) - (b.order || 0));
    },
    isAllSelected() {
      return this.selected.length === this.produtos.length;
    },
    isIndeterminate() {
      return this.selected.length > 0 && !this.isAllSelected;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selected = val;
      },
    },
  },
  methods: {
    toggleSelectAll() {
      this.selected = this.isAllSelected ? [] : [...this.produtos];
      this.emitSelectedValues();
    },
    removeItem(item) {
      this.selected = this.selected.filter(i => i.value !== item.value);
      this.emitSelectedValues();
    },
    emitSelectedValues() {
      const onlyValues = this.selected.map(i => i.value);
      this.$emit('input', this.selected); // v-model two-way
      this.$emit('change', onlyValues); // apenas os values
    },
  },
};
</script>
